export enum Differentiation {
  GreenCircle = 1,
  BlueSquare = 2,
  BlackDiamond = 3,
  SelfAssessment = 4,
  AnchorMap = 5,
  UnitQuiz = 6,
  OrangeCross = 7,
}
